import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { CandidateData } from '@core/tellent-assistant-types';
import { BadgeComponent } from '@core/user-interface-legacy';

import { ListCardComponent } from '../../list-card/list-card.component';
import { ListRowPersonComponent } from '../../rows/list-row-person.component';

@Component({
  selector: 'rt-list-item-candidate',
  imports: [BadgeComponent, ListCardComponent, ListRowPersonComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-candidate.component.html',
  styleUrl: './list-item-candidate.component.less',
})
export class ListItemCandidateComponent {
  public readonly data = input.required<CandidateData>();
}
